// import React, { useState, useRef } from 'react';
// import { UploadCloud, Trash2, Youtube, CheckCircle, User, MapPin } from 'lucide-react';
// import './AuditionForm.css'; // Import the CSS file

// export default function AuditionForm() {
//   // --- 1. STATE MANAGEMENT ---
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [isSuccess, setIsSuccess] = useState(false);
  
//   // Form Data State
//   const [formData, setFormData] = useState({
//     fullName: '',
//     age: '',
//     contactNo: '',
//     email: '',
//     city: '',
//     category: '',
//     productionType: '',
//     title: '',
//     experience: '',
//     roleDescription: '',
//     locationDates: '',
//     youtubeLink: ''
//   });

//   // Image Handling State
//   const [selectedImages, setSelectedImages] = useState([]); 
//   const [previewUrls, setPreviewUrls] = useState([]); 
//   const fileInputRef = useRef(null);

//   // --- 2. HANDLERS ---
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleImageChange = (e) => {
//     const files = Array.from(e.target.files);
//     if (selectedImages.length + files.length > 4) {
//       alert("You can only upload a maximum of 4 images.");
//       return;
//     }
//     const newPreviews = files.map(file => URL.createObjectURL(file));
//     setSelectedImages(prev => [...prev, ...files]);
//     setPreviewUrls(prev => [...prev, ...newPreviews]);
//   };

//   const removeImage = (index) => {
//     const newImages = selectedImages.filter((_, i) => i !== index);
//     const newPreviews = previewUrls.filter((_, i) => i !== index);
//     setSelectedImages(newImages);
//     setPreviewUrls(newPreviews);
//   };
 

//  const handleSubmit = async (e) => {
//   e.preventDefault();
//   setIsSubmitting(true);

//   try {
//     // STEP 1: Request presigned URLs
//     const presignRes = await fetch(
//       "https://r32gjrlmte.execute-api.ap-south-1.amazonaws.com/dev/presigned-urls",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           files: selectedImages.map((img) => ({
//             name: img.name,
//             type: img.type
//           }))
//         })
//       }
//     );

//     if (!presignRes.ok) {
//       throw new Error("Failed to get presigned URLs");
//     }

//     const { presignedUrls, propertyId } = await presignRes.json();

//     // STEP 2: Upload each image to S3 using the presigned URL
//     for (let i = 0; i < selectedImages.length; i++) {
//       await fetch(presignedUrls[i].url, {
//         method: "PUT",
//         headers: { "Content-Type": selectedImages[i].type },
//         body: selectedImages[i]
//       });
//     }

//     // STEP 3: Submit final audition data
//     const finalPayload = {
//       ...formData,
//       propertyId,
//       images: presignedUrls.map((p) => p.key)
//     };

//     const submitRes = await fetch(
//       "https://fs1w4qkflb.execute-api.ap-south-1.amazonaws.com/proud/audtionsform",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(finalPayload)
//       }
//     );

//     if (!submitRes.ok) throw new Error("Submission failed");

//     setIsSubmitting(false);
//     setIsSuccess(true);
//     window.scrollTo(0, 0);

//   } catch (error) {
//     console.error(error);
//     alert("Something went wrong. Try again.");
//     setIsSubmitting(false);
//   }
// };



//   // --- 3. RENDER ---

//   if (isSuccess) {
//     return (
//       <div className="audition-container">
//         <div className="success-card">
//           <div className="success-icon">
//             <CheckCircle size={40} />
//           </div>
//           <h2 className="success-title">Submission Received!</h2>
//           <p className="success-msg">
//             Thank you, {formData.fullName}. We have received your audition details and images.
//             Our team will review your profile and you will receive an email/call if shortlisted.
//           </p>
//           <button 
//             onClick={() => window.location.reload()}
//             className="submit-btn"
//           >
//             Submit Another
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="audition-container">
//       <div className="form-card">
        
//         {/* Header */}
//         <div className="form-header">
//           <h1>Audition Application Form</h1>
//           <p>Please fill out all details accurately. Incomplete forms may be rejected.</p>
//         </div>

//         <form onSubmit={handleSubmit} className="form-body">
          
//           {/* SECTION 1: PHOTOS */}
//           <div className="form-section">
//             <h3 className="section-title">1. Portfolio Photos</h3>
//             <p className="section-desc">Upload 3-4 high-quality images (Headshots, Full body). Max 5MB each.</p>
            
//             <div className="image-grid">
//               {previewUrls.map((url, index) => (
//                 <div key={index} className="image-preview">
//                   <img src={url} alt="Preview" />
//                   <button 
//                     type="button"
//                     onClick={() => removeImage(index)}
//                     className="delete-btn"
//                   >
//                     <Trash2 size={16} />
//                   </button>
//                 </div>
//               ))}

//               {/* Upload Button */}
//               {previewUrls.length < 4 && (
//                 <div 
//                   onClick={() => fileInputRef.current.click()}
//                   className="upload-box"
//                 >
//                   <UploadCloud size={32} />
//                   <span>Add Photo</span>
//                 </div>
//               )}
//             </div>
//             <input 
//               type="file" 
//               ref={fileInputRef}
//               onChange={handleImageChange}
//               accept="image/*"
//               multiple
//               className="hidden"
//               style={{ display: 'none' }}
//             />
//           </div>

//           {/* SECTION 2: PERSONAL DETAILS */}
//           <div className="form-section">
//             <h3 className="section-title">2. Personal Information</h3>
            
//             <div className="form-grid">
//               <div className="form-group">
//                 <label>Category</label>
//                 <select 
//                   name="category" 
//                   value={formData.category} 
//                   onChange={handleInputChange}
//                   className="form-select"
//                 >
//                   <option>Actor</option>
//                   <option>Dancer</option>
//                   <option>Model</option>
//                   <option>Singer</option>
//                   <option>Voice Artist</option>
//                 </select>
//               </div>

//               <div className="form-group">
//                 <label>Full Name</label>
//                 <div className="input-wrapper">
//                   <span className="input-icon"><User size={18} /></span>
//                   <input 
//                     type="text" 
//                     name="fullName"
//                     required
//                     value={formData.fullName}
//                     onChange={handleInputChange}
//                     className="form-input has-icon"
//                     placeholder="John Doe"
//                   />
//                 </div>
//               </div>

//               <div className="form-group">
//                 <label>Age</label>
//                 <input 
//                   type="number" 
//                   name="age"
//                   required
//                   value={formData.age}
//                   onChange={handleInputChange}
//                   className="form-input"
//                   placeholder="25"
//                 />
//               </div>

//               <div className="form-group">
//                 <label>Current City</label>
//                 <div className="input-wrapper">
//                   <span className="input-icon"><MapPin size={18} /></span>
//                   <input 
//                     type="text" 
//                     name="city"
//                     required
//                     value={formData.city}
//                     onChange={handleInputChange}
//                     className="form-input has-icon"
//                     placeholder="Mumbai, Pune..."
//                   />
//                 </div>
//               </div>

//               <div className="form-group">
//                 <label>Contact Number</label>
//                 <input 
//                   type="tel" 
//                   name="contactNo"
//                   required
//                   value={formData.contactNo}
//                   onChange={handleInputChange}
//                   className="form-input"
//                   placeholder="+91 98765 43210"
//                 />
//               </div>

//               <div className="form-group">
//                 <label>Email Address</label>
//                 <input 
//                   type="email" 
//                   name="email"
//                   required
//                   value={formData.email}
//                   onChange={handleInputChange}
//                   className="form-input"
//                   placeholder="you@example.com"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* SECTION 3: AUDITION / WORK DETAILS */}
//           <div className="form-section">
//             <h3 className="section-title">3. Audition Details</h3>
            
//             <div className="form-grid">
//                <div className="form-group">
//                 <label>Production Type</label>
//                 <select 
//                   name="productionType"
//                   value={formData.productionType}
//                   onChange={handleInputChange}
//                   className="form-select"
//                 >
//                   <option>Film</option>
//                   <option>TV Commercial (Ad)</option>
//                   <option>Theatre</option>
//                   <option>Web Series</option>
//                   <option>Short Film</option>
//                 </select>
//               </div>

//               <div className="form-group">
//                 <label>Years of Experience</label>
//                 <input 
//                   type="text" 
//                   name="experience"
//                   value={formData.experience}
//                   onChange={handleInputChange}
//                   className="form-input"
//                   placeholder="e.g., 2 Years, Fresher"
//                 />
//               </div>

//               <div className="form-group full-width">
//                 <label>Role Description / Character Applied For</label>
//                 <textarea 
//                   name="roleDescription"
//                   rows="3"
//                   value={formData.roleDescription}
//                   onChange={handleInputChange}
//                   className="form-textarea"
//                   placeholder="Briefly describe the role you are auditioning for..."
//                 ></textarea>
//               </div>

//               <div className="form-group full-width">
//                 <label>Production Title / Project Name</label>
//                  <input 
//                   type="text" 
//                   name="title"
//                   value={formData.title}
//                   onChange={handleInputChange}
//                   className="form-input"
//                   placeholder="e.g., 'Summer Dreams' - Short Film"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* SECTION 4: VIDEO LINK */}
//           <div className="form-section video-section">
//             <h3 className="section-title" style={{border: 'none', marginBottom: '0.5rem'}}>
//               <Youtube className="icon-inline" size={24} style={{marginRight: '8px', verticalAlign: 'bottom', color: '#red'}} /> 
//               4. Audition Video
//             </h3>
//             <p className="section-desc">
//               Please upload your audition to YouTube as <strong>Unlisted</strong> or <strong>Private (Shareable)</strong> and paste the link below.
//             </p>
            
//             <div className="form-group">
//               <label>YouTube Link</label>
//               <input 
//                 type="url" 
//                 name="youtubeLink"
//                 required
//                 value={formData.youtubeLink}
//                 onChange={handleInputChange}
//                 className="form-input"
//                 placeholder="https://youtu.be/..."
//               />
//             </div>
//           </div>

//           {/* SUBMIT BUTTON */}
//           <div className="form-actions">
//             <button 
//               type="submit" 
//               disabled={isSubmitting}
//               className="submit-btn"
//             >
//               {isSubmitting ? 'Uploading & Submitting...' : 'Submit Application'}
//             </button>
//             <p className="disclaimer">
//               By submitting, you agree that your information and images will be stored securely for casting purposes.
//             </p>
//           </div>

//         </form>
//       </div>
//     </div>
//   );
// }


// //Updated 3 Dec 2025
// import React, { useState, useRef } from 'react';
// import { UploadCloud, Trash2, Youtube, CheckCircle, User, MapPin, Plus, X } from 'lucide-react';
// import './AuditionForm.css';

// export default function AuditionForm() {
//   // --- 1. STATE MANAGEMENT ---
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [isSuccess, setIsSuccess] = useState(false);
  
//   // Form Data State
//   const [formData, setFormData] = useState({
//     fullName: '',
//     dob: '', // Changed from age to dob
//     gender: '', // Added Gender
//     contactNo: '',
//     email: '',
//     city: '',
//     category: 'Actor', // Default
//     productionType: '',
//     title: '',
//     experience: '', // Years of experience
//     pastExperience: '', // Detailed text
//     pastProjects: '', // Detailed text
//     roleDescription: '',
//     youtubeLink: ''
//   });

//   // Social Media State (Dynamic List)
//   const [socialLinks, setSocialLinks] = useState([
//     { platform: 'Instagram', handle: '' }
//   ]);

//   // Image Handling State
//   const [selectedImages, setSelectedImages] = useState([]); 
//   const [previewUrls, setPreviewUrls] = useState([]); 
//   const fileInputRef = useRef(null);

//   // --- 2. HANDLERS ---
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   // -- Image Handlers --
//   const handleImageChange = (e) => {
//     const files = Array.from(e.target.files);
//     if (selectedImages.length + files.length > 4) {
//       alert("You can only upload a maximum of 4 images.");
//       return;
//     }
//     const newPreviews = files.map(file => URL.createObjectURL(file));
//     setSelectedImages(prev => [...prev, ...files]);
//     setPreviewUrls(prev => [...prev, ...newPreviews]);
//   };

//   const removeImage = (index) => {
//     const newImages = selectedImages.filter((_, i) => i !== index);
//     const newPreviews = previewUrls.filter((_, i) => i !== index);
//     setSelectedImages(newImages);
//     setPreviewUrls(newPreviews);
//   };

//   // -- Social Media Handlers --
//   const handleSocialChange = (index, field, value) => {
//     const updatedLinks = [...socialLinks];
//     updatedLinks[index][field] = value;
//     setSocialLinks(updatedLinks);
//   };

//   const addSocialLink = () => {
//     setSocialLinks([...socialLinks, { platform: 'Instagram', handle: '' }]);
//   };

//   const removeSocialLink = (index) => {
//     const updatedLinks = socialLinks.filter((_, i) => i !== index);
//     setSocialLinks(updatedLinks);
//   };

//   // -- Helper: Calculate Age --
//   const calculateAge = (dobString) => {
//     const birthDate = new Date(dobString);
//     const today = new Date();
//     let age = today.getFullYear() - birthDate.getFullYear();
//     const m = today.getMonth() - birthDate.getMonth();
//     if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
//       age--;
//     }
//     return age;
//   };

//   // -- Submit Handler --
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Validation 1: At least one photo
//     if (selectedImages.length === 0) {
//       alert("Please upload at least one portfolio photo.");
//       return;
//     }

//     setIsSubmitting(true);

//     try {
//       // Calculate Age
//       const calculatedAge = calculateAge(formData.dob);

//       // STEP 1: Request presigned URLs
//       const presignRes = await fetch(
//         "https://r32gjrlmte.execute-api.ap-south-1.amazonaws.com/dev/presigned-urls",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             files: selectedImages.map((img) => ({
//               name: img.name,
//               type: img.type
//             }))
//           })
//         }
//       );

//       if (!presignRes.ok) throw new Error("Failed to get presigned URLs");

//       const { presignedUrls, propertyId } = await presignRes.json();

//       // STEP 2: Upload each image to S3
//       for (let i = 0; i < selectedImages.length; i++) {
//         await fetch(presignedUrls[i].url, {
//           method: "PUT",
//           headers: { "Content-Type": selectedImages[i].type },
//           body: selectedImages[i]
//         });
//       }

//       // STEP 3: Submit final data
//       const finalPayload = {
//         ...formData,
//         age: calculatedAge, // Sending the calculated age number
//         socialMedia: socialLinks, // Sending the array of social handles
//         propertyId,
//         images: presignedUrls.map((p) => p.key)
//       };

//       const submitRes = await fetch(
//         "https://fs1w4qkflb.execute-api.ap-south-1.amazonaws.com/proud/audtionsform",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(finalPayload)
//         }
//       );

//       if (!submitRes.ok) throw new Error("Submission failed");

//       setIsSubmitting(false);
//       setIsSuccess(true);
//       window.scrollTo(0, 0);

//     } catch (error) {
//       console.error(error);
//       alert("Something went wrong. Try again.");
//       setIsSubmitting(false);
//     }
//   };


//   // --- 3. RENDER ---

//   if (isSuccess) {
//     return (
//       <div className="audition-container">
//         <div className="success-card">
//           <div className="success-icon">
//             <CheckCircle size={40} />
//           </div>
//           <h2 className="success-title">Registration Successful!</h2>
//           <p className="success-msg">
//             Thank you, {formData.fullName}. We have received your registration details and images.
//             Our team will review your profile.
//           </p>
//           <button 
//             onClick={() => window.location.reload()}
//             className="submit-btn"
//           >
//             Register Another
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="audition-container">
//       <div className="form-card">
        
//         {/* Header */}
//         <div className="form-header">
//           <h1>Audition Registration</h1>
//           <p>Please fill out all details accurately. Incomplete forms may be rejected.</p>
//         </div>

//         <form onSubmit={handleSubmit} className="form-body">
          
//           {/* SECTION 1: PHOTOS (Mandatory) */}
//           <div className="form-section">
//             <h3 className="section-title">1. Portfolio Photos <span className="required-star">*</span></h3>
//             <p className="section-desc">Upload 1-4 high-quality images. At least one is mandatory.</p>
            
//             <div className="image-grid">
//               {previewUrls.map((url, index) => (
//                 <div key={index} className="image-preview">
//                   <img src={url} alt="Preview" />
//                   <button 
//                     type="button"
//                     onClick={() => removeImage(index)}
//                     className="delete-btn"
//                   >
//                     <Trash2 size={16} />
//                   </button>
//                 </div>
//               ))}

//               {/* Upload Button */}
//               {previewUrls.length < 4 && (
//                 <div 
//                   onClick={() => fileInputRef.current.click()}
//                   className="upload-box"
//                 >
//                   <UploadCloud size={32} />
//                   <span>Add Photo</span>
//                 </div>
//               )}
//             </div>
//             <input 
//               type="file" 
//               ref={fileInputRef}
//               onChange={handleImageChange}
//               accept="image/*"
//               multiple
//               className="hidden"
//               style={{ display: 'none' }}
//             />
//           </div>

//           {/* SECTION 2: PERSONAL DETAILS */}
//           <div className="form-section">
//             <h3 className="section-title">2. Personal Information</h3>
            
//             <div className="form-grid">
              
//               {/* Full Name */}
//               <div className="form-group">
//                 <label>Full Name <span className="required-star">*</span></label>
//                 <div className="input-wrapper">
//                   <span className="input-icon"><User size={18} /></span>
//                   <input 
//                     type="text" 
//                     name="fullName"
//                     required
//                     value={formData.fullName}
//                     onChange={handleInputChange}
//                     className="form-input has-icon"
//                     placeholder="John Doe"
//                   />
//                 </div>
//               </div>

//               {/* Category */}
//               <div className="form-group">
//                 <label>Category <span className="required-star">*</span></label>
//                 <select 
//                   name="category" 
//                   value={formData.category} 
//                   onChange={handleInputChange}
//                   className="form-select"
//                 >
//                   <option>Actor</option>
//                   <option>Dancer</option>
//                   <option>Model</option>
//                   <option>Singer</option>
//                   <option>Voice Artist</option>
//                   <option>Other</option>
//                 </select>
//               </div>

//               {/* Date of Birth (Replaces Age) */}
//               <div className="form-group">
//                 <label>Date of Birth <span className="required-star">*</span></label>
//                 <input 
//                   type="date" 
//                   name="dob"
//                   required
//                   value={formData.dob}
//                   onChange={handleInputChange}
//                   className="form-input"
//                 />
//               </div>

//               {/* Gender (New) */}
//               <div className="form-group">
//                 <label>Gender <span className="required-star">*</span></label>
//                 <select 
//                   name="gender" 
//                   required
//                   value={formData.gender} 
//                   onChange={handleInputChange}
//                   className="form-select"
//                 >
//                   <option value="">Select Gender</option>
//                   <option value="Male">Male</option>
//                   <option value="Female">Female</option>
//                   <option value="Other">Other</option>
//                 </select>
//               </div>

//               {/* City */}
//               <div className="form-group">
//                 <label>Current City <span className="required-star">*</span></label>
//                 <div className="input-wrapper">
//                   <span className="input-icon"><MapPin size={18} /></span>
//                   <input 
//                     type="text" 
//                     name="city"
//                     required
//                     value={formData.city}
//                     onChange={handleInputChange}
//                     className="form-input has-icon"
//                     placeholder="Mumbai, Pune..."
//                   />
//                 </div>
//               </div>

//               {/* Contact */}
//               <div className="form-group">
//                 <label>Contact Number <span className="required-star">*</span></label>
//                 <input 
//                   type="tel" 
//                   name="contactNo"
//                   required
//                   value={formData.contactNo}
//                   onChange={handleInputChange}
//                   className="form-input"
//                   placeholder="+91 98765 43210"
//                 />
//               </div>

//               {/* Email */}
//               <div className="form-group full-width">
//                 <label>Email Address <span className="required-star">*</span></label>
//                 <input 
//                   type="email" 
//                   name="email"
//                   required
//                   value={formData.email}
//                   onChange={handleInputChange}
//                   className="form-input"
//                   placeholder="you@example.com"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* SECTION 3: AUDITION / WORK DETAILS */}
//           <div className="form-section">
//             <h3 className="section-title">3. Experience & Project Details</h3>
            
//             <div className="form-grid">
              
//               {/* Production Type (Mandatory + Other) */}
//                <div className="form-group">
//                 <label>Production Type <span className="required-star">*</span></label>
//                 <select 
//                   name="productionType"
//                   required
//                   value={formData.productionType}
//                   onChange={handleInputChange}
//                   className="form-select"
//                 >
//                   <option value="">Select Type</option>
//                   <option>Film</option>
//                   <option>TV Commercial (Ad)</option>
//                   <option>Theatre</option>
//                   <option>Web Series</option>
//                   <option>Short Film</option>
//                   <option>Other</option>
//                 </select>
//               </div>

//               {/* Title */}
//               <div className="form-group">
//                 <label>Production Title / Project Name</label>
//                  <input 
//                   type="text" 
//                   name="title"
//                   value={formData.title}
//                   onChange={handleInputChange}
//                   className="form-input"
//                   placeholder="e.g., 'Summer Dreams'"
//                 />
//               </div>

//               {/* Years Experience */}
//               <div className="form-group full-width">
//                 <label>Years of Experience</label>
//                 <input 
//                   type="text" 
//                   name="experience"
//                   value={formData.experience}
//                   onChange={handleInputChange}
//                   className="form-input"
//                   placeholder="e.g., 2 Years, Fresher"
//                 />
//               </div>

//               {/* Role Description (Mandatory) */}
//               <div className="form-group full-width">
//                 <label>Role Description / Character Applied For <span className="required-star">*</span></label>
//                 <textarea 
//                   name="roleDescription"
//                   required
//                   rows="3"
//                   value={formData.roleDescription}
//                   onChange={handleInputChange}
//                   className="form-textarea"
//                   placeholder="Briefly describe the role you are auditioning for..."
//                 ></textarea>
//               </div>

//               {/* Past Projects (Optional) */}
//               <div className="form-group full-width">
//                 <label>Past Projects (Optional)</label>
//                 <textarea 
//                   name="pastProjects"
//                   rows="2"
//                   value={formData.pastProjects}
//                   onChange={handleInputChange}
//                   className="form-textarea"
//                   placeholder="List significant previous work..."
//                 ></textarea>
//               </div>

//               {/* Past Experience Details (Optional) */}
//               <div className="form-group full-width">
//                 <label>Past Experience Details (Optional)</label>
//                 <textarea 
//                   name="pastExperience"
//                   rows="2"
//                   value={formData.pastExperience}
//                   onChange={handleInputChange}
//                   className="form-textarea"
//                   placeholder="Any training, workshops, or additional experience..."
//                 ></textarea>
//               </div>
//             </div>
//           </div>
          

//           {/* SECTION 4: SOCIAL MEDIA (New) */}
//           <div className="form-section">
//             <h3 className="section-title">4. Social Media (Optional)</h3>
//             <p className="section-desc">Add your social media handles (Instagram, YouTube, etc).</p>
            
//             {socialLinks.map((link, index) => (
//               <div key={index} className="social-row">
//                 <select
//                   value={link.platform}
//                   onChange={(e) => handleSocialChange(index, 'platform', e.target.value)}
//                   className="form-select social-select"
//                 >
//                   <option>Instagram</option>
//                   <option>YouTube</option>
//                   <option>Facebook</option>
//                   <option>Twitter/X</option>
//                   <option>LinkedIn</option>
//                   <option>Website</option>
//                 </select>
                
//                 <input 
//                   type="text"
//                   value={link.handle}
//                   onChange={(e) => handleSocialChange(index, 'handle', e.target.value)}
//                   className="form-input social-input"
//                   placeholder="Username or Link"
//                 />

//                 {/* Only show remove button if there's more than 1 item or it has content, 
//                     but usually users like to remove even the last one. 
//                     Let's allow removing specific lines. */}
//                 <button 
//                   type="button" 
//                   onClick={() => removeSocialLink(index)}
//                   className="icon-btn danger"
//                 >
//                   <X size={18} />
//                 </button>
//               </div>
//             ))}
            
//             <button type="button" onClick={addSocialLink} className="add-social-btn">
//               <Plus size={16} style={{ marginRight: '5px' }} /> Add Another Handle
//             </button>
//           </div>

//           {/* SECTION 5: VIDEO LINK */}
//           <div className="form-section video-section">
//             <h3 className="section-title" style={{border: 'none', marginBottom: '0.5rem'}}>
//               <Youtube className="icon-inline" size={24} style={{marginRight: '8px', verticalAlign: 'bottom', color: 'red'}} /> 
//               5. Audition Video
//             </h3>
//             <p className="section-desc">
//               Please upload your audition to YouTube as <strong>Unlisted</strong> or <strong>Private (Shareable)</strong>.
//             </p>
            
//             <div className="form-group">
//               <label>YouTube Link <span className="required-star">*</span></label>
//               <input 
//                 type="url" 
//                 name="youtubeLink"
//                 required
//                 value={formData.youtubeLink}
//                 onChange={handleInputChange}
//                 className="form-input"
//                 placeholder="https://youtu.be/..."
//               />
//             </div>
//           </div>

//           {/* SUBMIT BUTTON */}
//           <div className="form-actions">
//             <button 
//               type="submit" 
//               disabled={isSubmitting}
//               className="submit-btn"
//             >
//               {isSubmitting ? 'Registering...' : 'Register me'}
//             </button>
//             <p className="disclaimer">
//               By registering, you agree that your information and images will be stored securely for casting purposes.
//             </p>
//           </div>

//         </form>
//       </div>
//     </div>
//   );
// }


//06/12/2025
//Updated 3 Dec 2025
import React, { useState, useRef } from 'react';
import { UploadCloud, Trash2, Youtube, CheckCircle, User, MapPin, Plus, X } from 'lucide-react';
import './AuditionForm.css';

export default function AuditionForm() {
  // --- 1. STATE MANAGEMENT ---
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  
  // Form Data State
  const [formData, setFormData] = useState({
    fullName: '',
    dob: '', 
    gender: '', 
    contactNo: '',
    email: '',
    city: '',
    category: 'Actor', 
    productionType: '',
    title: '',
    experience: '', 
    pastExperience: '', 
    pastProjects: '', 
    roleDescription: '',
    otherDetails: '', // <--- NEW FIELD ADDED HERE
    youtubeLink: ''
  });

  // Social Media State (Dynamic List)
  const [socialLinks, setSocialLinks] = useState([
    { platform: 'Instagram', handle: '' }
  ]);

  // Image Handling State
  const [selectedImages, setSelectedImages] = useState([]); 
  const [previewUrls, setPreviewUrls] = useState([]); 
  const fileInputRef = useRef(null);

  // --- 2. HANDLERS ---
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // -- Image Handlers --
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    if (selectedImages.length + files.length > 4) {
      alert("You can only upload a maximum of 4 images.");
      return;
    }
    const newPreviews = files.map(file => URL.createObjectURL(file));
    setSelectedImages(prev => [...prev, ...files]);
    setPreviewUrls(prev => [...prev, ...newPreviews]);
  };

  const removeImage = (index) => {
    const newImages = selectedImages.filter((_, i) => i !== index);
    const newPreviews = previewUrls.filter((_, i) => i !== index);
    setSelectedImages(newImages);
    setPreviewUrls(newPreviews);
  };

  // -- Social Media Handlers --
  const handleSocialChange = (index, field, value) => {
    const updatedLinks = [...socialLinks];
    updatedLinks[index][field] = value;
    setSocialLinks(updatedLinks);
  };

  const addSocialLink = () => {
    setSocialLinks([...socialLinks, { platform: 'Instagram', handle: '' }]);
  };

  const removeSocialLink = (index) => {
    const updatedLinks = socialLinks.filter((_, i) => i !== index);
    setSocialLinks(updatedLinks);
  };

  // -- Helper: Calculate Age --
  const calculateAge = (dobString) => {
    const birthDate = new Date(dobString);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  // -- Submit Handler --
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation 1: At least one photo
    if (selectedImages.length === 0) {
      alert("Please upload at least one portfolio photo.");
      return;
    }

    setIsSubmitting(true);

    try {
      // Calculate Age
      const calculatedAge = calculateAge(formData.dob);

      // STEP 1: Request presigned URLs
      const presignRes = await fetch(
        "https://r32gjrlmte.execute-api.ap-south-1.amazonaws.com/dev/presigned-urls",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            files: selectedImages.map((img) => ({
              name: img.name,
              type: img.type
            }))
          })
        }
      );

      if (!presignRes.ok) throw new Error("Failed to get presigned URLs");

      const { presignedUrls, propertyId } = await presignRes.json();

      // STEP 2: Upload each image to S3
      for (let i = 0; i < selectedImages.length; i++) {
        await fetch(presignedUrls[i].url, {
          method: "PUT",
          headers: { "Content-Type": selectedImages[i].type },
          body: selectedImages[i]
        });
      }

      // STEP 3: Submit final data
      const finalPayload = {
        ...formData,
        age: calculatedAge, 
        socialMedia: socialLinks, 
        propertyId,
        images: presignedUrls.map((p) => p.key)
      };

      const submitRes = await fetch(
        "https://fs1w4qkflb.execute-api.ap-south-1.amazonaws.com/proud/audtionsform",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(finalPayload)
        }
      );

      if (!submitRes.ok) throw new Error("Submission failed");

      setIsSubmitting(false);
      setIsSuccess(true);
      window.scrollTo(0, 0);

    } catch (error) {
      console.error(error);
      alert("Something went wrong. Try again.");
      setIsSubmitting(false);
    }
  };


  // --- 3. RENDER ---

  if (isSuccess) {
    return (
      <div className="audition-container">
        <div className="success-card">
          <div className="success-icon">
            <CheckCircle size={40} />
          </div>
          <h2 className="success-title">Registration Successful!</h2>
          <p className="success-msg">
            Thank you, {formData.fullName}. We have received your registration details and images.
            Our team will review your profile.
          </p>
          <button 
            onClick={() => window.location.reload()}
            className="submit-btn"
          >
            Register Another
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="audition-container">
      <div className="form-card">
        
        {/* Header */}
        <div className="form-header">
          <h1>Audition Registration</h1>
          <p>Please fill out all details accurately. Incomplete forms may be rejected.</p>
        </div>

        <form onSubmit={handleSubmit} className="form-body">
          
          {/* SECTION 1: PHOTOS (Mandatory) */}
          <div className="form-section">
            <h3 className="section-title">1. Portfolio Photos <span className="required-star">*</span></h3>
            <p className="section-desc">Upload 1-4 high-quality images. At least one is mandatory.</p>
            
            <div className="image-grid">
              {previewUrls.map((url, index) => (
                <div key={index} className="image-preview">
                  <img src={url} alt="Preview" />
                  <button 
                    type="button"
                    onClick={() => removeImage(index)}
                    className="delete-btn"
                  >
                    <Trash2 size={16} />
                  </button>
                </div>
              ))}

              {/* Upload Button */}
              {previewUrls.length < 4 && (
                <div 
                  onClick={() => fileInputRef.current.click()}
                  className="upload-box"
                >
                  <UploadCloud size={32} />
                  <span>Add Photo</span>
                </div>
              )}
            </div>
            <input 
              type="file" 
              ref={fileInputRef}
              onChange={handleImageChange}
              accept="image/*"
              multiple
              className="hidden"
              style={{ display: 'none' }}
            />
          </div>

          {/* SECTION 2: PERSONAL DETAILS */}
          <div className="form-section">
            <h3 className="section-title">2. Personal Information</h3>
            
            <div className="form-grid">
              
              {/* Full Name */}
              <div className="form-group">
                <label>Full Name <span className="required-star">*</span></label>
                <div className="input-wrapper">
                  <span className="input-icon"><User size={18} /></span>
                  <input 
                    type="text" 
                    name="fullName"
                    required
                    value={formData.fullName}
                    onChange={handleInputChange}
                    className="form-input has-icon"
                    placeholder="John Doe"
                  />
                </div>
              </div>

              {/* Category */}
              <div className="form-group">
                <label>Category <span className="required-star">*</span></label>
                <select 
                  name="category" 
                  value={formData.category} 
                  onChange={handleInputChange}
                  className="form-select"
                >
                  <option>Actor</option>
                  <option>Dancer</option>
                  <option>Model</option>
                  <option>Singer</option>
                  <option>Voice Artist</option>
                  <option>Other</option>
                </select>
              </div>

              {/* Date of Birth */}
              <div className="form-group">
                <label>Date of Birth <span className="required-star">*</span></label>
                <input 
                  type="date" 
                  name="dob"
                  required
                  value={formData.dob}
                  onChange={handleInputChange}
                  className="form-input"
                />
              </div>

              {/* Gender */}
              <div className="form-group">
                <label>Gender <span className="required-star">*</span></label>
                <select 
                  name="gender" 
                  required
                  value={formData.gender} 
                  onChange={handleInputChange}
                  className="form-select"
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              {/* City */}
              <div className="form-group">
                <label>Current City <span className="required-star">*</span></label>
                <div className="input-wrapper">
                  <span className="input-icon"><MapPin size={18} /></span>
                  <input 
                    type="text" 
                    name="city"
                    required
                    value={formData.city}
                    onChange={handleInputChange}
                    className="form-input has-icon"
                    placeholder="Mumbai, Pune..."
                  />
                </div>
              </div>

              {/* Contact */}
              <div className="form-group">
                <label>Contact Number <span className="required-star">*</span></label>
                <input 
                  type="tel" 
                  name="contactNo"
                  required
                  value={formData.contactNo}
                  onChange={handleInputChange}
                  className="form-input"
                  placeholder="+91 98765 43210"
                />
              </div>

              {/* Email */}
              <div className="form-group full-width">
                <label>Email Address <span className="required-star">*</span></label>
                <input 
                  type="email" 
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleInputChange}
                  className="form-input"
                  placeholder="you@example.com"
                />
              </div>
            </div>
          </div>

          {/* SECTION 3: AUDITION / WORK DETAILS */}
          <div className="form-section">
            <h3 className="section-title">3. Experience & Project Details</h3>
            
            <div className="form-grid">
              
              {/* Production Type */}
               <div className="form-group">
                <label>Production Type <span className="required-star">*</span></label>
                <select 
                  name="productionType"
                  required
                  value={formData.productionType}
                  onChange={handleInputChange}
                  className="form-select"
                >
                  <option value="">Select Type</option>
                  <option>Film</option>
                  <option>Advertisement</option>
                  <option>Theatre</option>
                  <option>Web Series</option>
                  <option>Short Film</option>
                  <option>Other</option>
                </select>
              </div>

              {/* Title */}
              <div className="form-group">
                <label>Production Title / Project Name</label>
                 <input 
                  type="text" 
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                  className="form-input"
                  placeholder="e.g., 'Summer Dreams'"
                />
              </div>

              {/* Years Experience */}
              <div className="form-group full-width">
                <label>Years of Experience</label>
                <input 
                  type="text" 
                  name="experience"
                  value={formData.experience}
                  onChange={handleInputChange}
                  className="form-input"
                  placeholder="e.g., 2 Years, Fresher"
                />
              </div>

              {/* Role Description */}
              <div className="form-group full-width">
                <label>Role Description / Character Applied For <span className="required-star">*</span></label>
                <textarea 
                  name="roleDescription"
                  required
                  rows="3"
                  value={formData.roleDescription}
                  onChange={handleInputChange}
                  className="form-textarea"
                  placeholder="Briefly describe the role you are auditioning for..."
                ></textarea>
              </div>

              {/* Past Projects */}
              <div className="form-group full-width">
                <label>Past Projects (Optional)</label>
                <textarea 
                  name="pastProjects"
                  rows="2"
                  value={formData.pastProjects}
                  onChange={handleInputChange}
                  className="form-textarea"
                  placeholder="List significant previous work..."
                ></textarea>
              </div>

              {/* Past Experience Details */}
              <div className="form-group full-width">
                <label>Past Experience Details (Optional)</label>
                <textarea 
                  name="pastExperience"
                  rows="2"
                  value={formData.pastExperience}
                  onChange={handleInputChange}
                  className="form-textarea"
                  placeholder="Any training, workshops, or additional experience..."
                ></textarea>
              </div>
            </div>
          </div>

          {/* SECTION 4: ANY OTHER DETAILS (NEW SECTION) */}
          <div className="form-section">
            <h3 className="section-title">4. Any Other Details</h3>
            <div className="form-group full-width">
              <label>Additional Information (Optional)</label>
              <textarea 
                name="otherDetails"
                rows="3"
                value={formData.otherDetails}
                onChange={handleInputChange}
                className="form-textarea"
                placeholder="Anything else you want us to know? (e.g., specific skills, availability constraints, etc.)"
              ></textarea>
            </div>
          </div>
          

          {/* SECTION 5: SOCIAL MEDIA (Renumbered) */}
          <div className="form-section">
            <h3 className="section-title">5. Social Media (Optional)</h3>
            <p className="section-desc">Add your social media handles (Instagram, YouTube, etc).</p>
            
            {socialLinks.map((link, index) => (
              <div key={index} className="social-row">
                <select
                  value={link.platform}
                  onChange={(e) => handleSocialChange(index, 'platform', e.target.value)}
                  className="form-select social-select"
                >
                  <option>Instagram</option>
                  <option>YouTube</option>
                  <option>Facebook</option>
                  <option>Twitter/X</option>
                  <option>LinkedIn</option>
                  <option>Website</option>
                </select>
                
                <input 
                  type="text"
                  value={link.handle}
                  onChange={(e) => handleSocialChange(index, 'handle', e.target.value)}
                  className="form-input social-input"
                  placeholder="Username or Link"
                />

                <button 
                  type="button" 
                  onClick={() => removeSocialLink(index)}
                  className="icon-btn danger"
                >
                  <X size={18} />
                </button>
              </div>
            ))}
            
            <button type="button" onClick={addSocialLink} className="add-social-btn">
              <Plus size={16} style={{ marginRight: '5px' }} /> Add Another Handle
            </button>
          </div>

          {/* SECTION 6: VIDEO LINK (Renumbered) */}
          <div className="form-section video-section">
            <h3 className="section-title" style={{border: 'none', marginBottom: '0.5rem'}}>
              <Youtube className="icon-inline" size={24} style={{marginRight: '8px', verticalAlign: 'bottom', color: 'red'}} /> 
              6. Audition Video
            </h3>
            <p className="section-desc">
              Please upload your audition to YouTube as <strong>Unlisted</strong> or <strong>Private (Shareable)</strong>.
            </p>
            
            <div className="form-group">
              <label>YouTube Link <span className="required-star">*</span></label>
              <input 
                type="url" 
                name="youtubeLink"
                required
                value={formData.youtubeLink}
                onChange={handleInputChange}
                className="form-input"
                placeholder="https://youtu.be/..."
              />
            </div>
          </div>

          {/* SUBMIT BUTTON */}
          <div className="form-actions">
            <button 
              type="submit" 
              disabled={isSubmitting}
              className="submit-btn"
            >
              {isSubmitting ? 'Registering...' : 'Register me'}
            </button>
            <p className="disclaimer">
              By registering, you agree that your information and images will be stored securely for casting purposes.
            </p>
          </div>

        </form>
      </div>
    </div>
  );
}